module.exports = __webpack_public_path__ + "img/sv4.5062e435.svg";